const APP_TIME_ZONE = "Europe/Berlin";

export function toSec(value) {
  if (value == null || value === "") return 0;

  if (typeof value === "number") {
    return value > 1e12 ? Math.floor(value / 1000) : Math.floor(value);
  }

  if (typeof value === "string") {
    const trimmed = value.trim();

    // reine Unix-Zahl als String
    if (/^\d+$/.test(trimmed)) {
      const n = Number(trimmed);
      return n > 1e12 ? Math.floor(n / 1000) : Math.floor(n);
    }

    // ISO-Date
    if (trimmed.includes("T")) {
      const parsed = new Date(trimmed);
      if (!Number.isNaN(parsed.getTime())) {
        return Math.floor(parsed.getTime() / 1000);
      }
    }

    // DD.MM.YYYY
    if (trimmed.includes(".")) {
      return convertDateToTimestamp(trimmed);
    }
  }

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return 0;
  return Math.floor(parsed.getTime() / 1000);
}

function formatPartsFromTs(tsSec, timeZone = APP_TIME_ZONE) {
  const date = new Date(tsSec * 1000);

  const parts = new Intl.DateTimeFormat("de-DE", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hourCycle: "h23",
  }).formatToParts(date);

  const map = Object.fromEntries(parts.map((p) => [p.type, p.value]));
  return {
    day: map.day ?? "00",
    month: map.month ?? "00",
    year: map.year ?? "0000",
    hour: map.hour ?? "00",
    minute: map.minute ?? "00",
    second: map.second ?? "00",
  };
}

export function formatDateFromTimestamp(value, timeZone = APP_TIME_ZONE) {
  const tsSec = toSec(value);
  if (!tsSec) return "—";

  const { day, month, year, hour, minute, second } = formatPartsFromTs(tsSec, timeZone);
  return `${day}.${month}.${year} ${hour}:${minute}:${second}`;
}

/**
 * PDF/Export-Ansicht: gleiche UTC-Darstellung wie CSV (inkl. "UTC"-Suffix).
 */
export function formatDateTimeUtcFromTimestamp(value) {
  const tsSec = toSec(value);
  if (!tsSec) return "—";

  const { day, month, year, hour, minute, second } = formatPartsFromTs(tsSec, "UTC");
  return `${day}.${month}.${year}, ${hour}:${minute}:${second} UTC`;
}

export function getYearFromTimestamp(value, timeZone = APP_TIME_ZONE) {
  const tsSec = toSec(value);
  if (!tsSec) return "";

  const { year } = formatPartsFromTs(tsSec, timeZone);
  return String(year || "");
}

export function convertDateToTimestamp(dateStr) {
  const [day, month, year] = String(dateStr || "").split(".");
  if (!day || !month || !year) return 0;

  // date-only immer stabil als UTC-Midnight speichern
  const date = new Date(`${year}-${month}-${day}T00:00:00Z`);
  if (Number.isNaN(date.getTime())) return 0;

  return Math.floor(date.getTime() / 1000);
}

export function parseDateToTimestamp(input) {
  return toSec(input);
}
